var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMaleColor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "male_1_",
    "data-name": "male (1)",
    transform: "translate(-15.004 -14.999)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_3",
    "data-name": "Subtraction 3",
    d: "M21193.477,6150a5.478,5.478,0,0,1,0-10.956,5.411,5.411,0,0,1,3.209,1.038l2.342-2.336h-1.092V6136H21202v4.065h-1.746v-1.085l-2.336,2.336a5.421,5.421,0,0,1,1.037,3.208A5.484,5.484,0,0,1,21193.477,6150Zm0-9.216a3.738,3.738,0,1,0,3.736,3.741A3.741,3.741,0,0,0,21193.477,6140.782Z",
    transform: "translate(-21173 -6121)",
    fill: "#1564e8"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaleColor);
export default __webpack_public_path__ + "static/media/male-color.0398507dc90bcb459438d782582266c8.svg";
export { ForwardRef as ReactComponent };